import React from 'react'
import { AssessmentTrend } from 'src/graphql.generated'

type RiskIconProps = {
  trend: AssessmentTrend
  width?: number | string
  height?: number | string
  className?: string
}

const TRIANGLE_WITH_ARROW =
  'M18.43 21.69H8.25C7.96 21.68 7.67 21.6 7.42 21.46C7.17 21.31 6.96 21.1 6.82 20.85C6.67 20.59 6.6 20.31 6.6 20.02C6.6 19.72 6.68 19.44 6.82 19.19L13.88 7.4C14.03 7.16 14.24 6.96 14.49 6.82C14.74 6.68 15.02 6.6 15.31 6.6C15.59 6.6 15.87 6.68 16.12 6.82C16.37 6.96 16.58 7.16 16.73 7.4L21.54 15.74M15.31 18.35H15.32M15.31 11.69V15.02'

const TRIANGLE_CENTERED =
  'M8.94 23.54C8.65 23.54 8.37 23.46 8.12 23.31C7.87 23.16 7.66 22.95 7.51 22.7C7.37 22.45 7.29 22.16 7.3 21.87C7.3 21.58 7.37 21.29 7.52 21.04L14.58 9.26C14.73 9.01 14.93 8.81 15.18 8.67C15.43 8.53 15.72 8.46 16 8.46C16.29 8.46 16.57 8.53 16.82 8.67C17.07 8.81 17.28 9.01 17.43 9.26L24.49 21.04C24.63 21.29 24.71 21.58 24.71 21.87C24.71 22.16 24.63 22.45 24.49 22.7C24.35 22.95 24.14 23.16 23.89 23.31C23.64 23.46 23.35 23.54 23.06 23.54ZM16 20.21H16.01M16 13.54V16.88'

const UP_ARROW = 'M25.4 24.32V18.9L20.2 18.9M25.4 18.9L19.16 25.4'

const DOWN_ARROW = 'M25.4 19.98V25.4L20.2 25.4M25.4 25.4L19.16 18.9'

const glyphByTrend: Record<AssessmentTrend, string> = {
  [AssessmentTrend.Increased]: `${UP_ARROW}${TRIANGLE_WITH_ARROW}`,
  [AssessmentTrend.Decreased]: `${DOWN_ARROW}${TRIANGLE_WITH_ARROW}`,
  [AssessmentTrend.Stable]: TRIANGLE_CENTERED,
}

export const RiskIcon = ({ trend, width = 20, height = 20, className }: RiskIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="6 6 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d={glyphByTrend[trend]} stroke="white" strokeWidth={1.2} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
